const text = {
    pt: "PT. Surya Langgeng Indonesia",
    contact: 'Please visit our website or contact us for a more detailed list of products and services'
}

export default text